query SalesAnalyticsGetClients{
  clients: SalesAnalyticsGetClients {
    id: clientId
    title: clientName
  }
}